import * as Yup from "yup";

const ProposicaoResultadosCreateSchema = Yup.object({
    descricao: Yup.string().required({ name: "descricao", err: "Campo com preenchimento obrigatório" }),
});

export default ProposicaoResultadosCreateSchema;
